import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import tags from '@components/ui-components/tags/tags';
import Pagination from '@components/ui-components/pagination/pagination.vue';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import { mapState } from "vuex";
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            searchText: '',
            newSearch: [],
            pagination: null,
        }
    },
    components: {
        'tags-cmp': tags,
        'pagination-cmp': Pagination,
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    methods: {
        submitSearch() {
            if (this.searchText.length > 2 && this.$route.query.q !== this.searchText) {
                this.$router.push({ name: 'search', query: {q: this.searchText} });
            }
            // else {
            //     this.$router.push({ name: 'search', query: {q: undefined} });
            // }
        },
        setSearchText(route) {
            if (route.query.q) {
                this.searchText = route.query.q;
            }
        },
        setText(len) {
            return this.$root.num2str(len, [
                this.$root.staticText.searchText[0], this.$root.staticText.searchText[1], this.$root.staticText.searchText[2]
            ]);
        },
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination-search");
                this.setMark();
            }, 100);
        },
        setMark() {
            document.querySelectorAll(".js-mark").forEach(item => {
                let instance = new Mark(item);
                instance.mark(this.searchText);
            });
        },
        unMark() {
            document.querySelectorAll(".js-mark").forEach(item => {
                let instance = new Mark(item);
                instance.unmark();
            });
        },
    },
    mounted() {
        this.setSearchText(this.$route);
        this.setPagination();
    },
    beforeRouteUpdate(to, from, next) {
        this.setSearchText(to);
        this.$root.setDataAnimateFalse('.js-content ');

        const path = to.path.replace(router.history.base, '');
        Vue.http.get(`templates${path}`, { params: to.query }).then(
            (data) => {
                next();
                this.unMark();
                setTimeout(() => {
                    this.template = data.data;
                    this.setPagination();
                    onScrollAnimate();
                    this.$root.scrollToBlock('.js-scroll');
                }, 500);
            },
            (data) => {
                if (data.status === 403) {
                    next({name: 'E403'});
                } else {
                    next({name: 'E404'});
                }
            }
        );
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/search/index.js